module.exports = __webpack_public_path__ + "img/gocourt_img.104e83fa.png";